import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PrincipalService } from '@core/auth/principal.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RouteAccessGuard  {
    
    constructor(private principal: PrincipalService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable(observer => {
            this.principal.getActiveUser()
                .subscribe(user => {
                        if (user) {
                            const authorities = route.data['authorities'];
                            observer.next(this.principal.hasAnyAuthority(authorities));
                        } else {
                            observer.next(false);
                        }
                    },
                    () => {
                        observer.next(false);
                    },
                    () => {
                        observer.next(false);
                    }
                );
        });
    }
}